
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/auth/find/send",
      function () {
        return require("private-next-pages/auth/find/send.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/auth/find/send"])
      });
    }
  